const ApiBaseUrl = process.env.REACT_APP_API_URL || '';
const IdentityBaseUrl = process.env.REACT_APP_IDENTITY_SERVICE_URL || '';

// Ensure ApiBaseUrl ends with a slash
const baseUrl = ApiBaseUrl.endsWith('/') ? ApiBaseUrl : ApiBaseUrl + '/';

export const ApiUrls = {
    base: ApiBaseUrl,
    catalogEndpoint: baseUrl + 'api/v1/catalog/',
    restaurantEndpoint: baseUrl + 'api/v1/restaurant/',
    storeAdminEndpoint: baseUrl + 'api/v1/store-admin/',
    dataViewEndpoint: baseUrl + 'api/v1/data-view/',
    membershipEndpoint: baseUrl + 'api/v1/web-membership/',
    batchEndpoint: baseUrl + 'api/v1/batch/',
    IdentityBaseUrl,
    doorDashEndpoint: baseUrl + 'api/door-dash/',
    doorDashMarketplaceEndpoint: process.env.REACT_APP_DOORDASH_MARKET_URL || ''
}